import React from "react";

const Image = ({ className, src, srcDark, srcSet, srcSetDark, alt }) => {
  const darkMode = false;

  return (
    <img
      className={className}
      srcSet={darkMode.value ? srcSetDark : srcSet}
      src={darkMode.value ? srcDark : src}
      alt={alt}
    />
  );
};

export default Image;
